import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CustomDataGrid from "src/@core/components/data-grid";
import { Chip, styled } from "@mui/material";

function TableSubAdmin({
  rows,
  totalCount,
  setCurrentPage,
  currentPage,
  setPageSize,
  pageSize,
  loading,
  toggleEdit,
  toggleStatus,
  toggleDelete,
}) {
  const statusColors = {
    Inactive: "#3a354182",
    Active: "#3fab3cb8",
  };
  const CustomChip = styled(Chip)(({ label }) => ({
    backgroundColor: statusColors[label] || statusColors.default,
    textTransform: "capitalize",
    color: "#fff",
    width: "100px",
  }));
  const rowData = rows.map((row) => ({
    ...row,
    roleName: row.roleInfo?.name,
  }));
  return (
    <CustomDataGrid
      loading={loading}
      rowCount={totalCount}
      rows={rowData}
      columns={[
        {
          field: "name",
          flex: 0.3, // Give some space but not too much
          minWidth: 150,
          sortable: false,
          headerName: "Name",
          renderCell: ({ row }) => (
            <Typography noWrap variant="body2" title={row.name}>
              {row.name}
            </Typography>
          ),
        },
        {
          field: "email",
          flex: 0.3, // Give some space but not too much
          minWidth: 180,
          sortable: false,
          headerName: "Email",
          renderCell: ({ row }) => (
            <Typography noWrap variant="body2" title={row.email}>
              {row.email}
            </Typography>
          ),
        },
        {
          field: "roleName",
          flex: 0.3, // Give some space but not too much
          minWidth: 180,
          sortable: false,
          headerName: "Role",
          renderCell: ({ row }) => (
            <Typography noWrap variant="body2" title={row.roleInfo?.name}>
              {row.roleInfo?.name}
            </Typography>
          ),
        },
        {
          field: "status_label",
          flex: 0.2, // Give some space but not too much
          minWidth: 100,
          sortable: false,
          headerName: "Status",
          renderCell: ({ row }) => (
            <>
              <CustomChip label={row.status_label}   onClick={() => toggleStatus(row)} />
            </>
          ),
        },
        {
          field: "Actions",
          flex: 0, // Keep it fixed
          minWidth: 170,
          sortable: false,
          headerName: "Actions",
          renderCell: ({ row }) => (
            <Box display="flex" alignItems="center" gap="10px">
              {/* <PermissionGuard permissionName="sub admin" action="update"> */}
                <IconButton
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={(e) => toggleEdit(e, "edit", row)}
                >
                  <EditIcon />
                </IconButton>
              {/* </PermissionGuard> */}

              {/* <PermissionGuard permissionName="sub admin" action="remove"> */}
                <IconButton
                  size="small"
                  color="primary"
                  onClick={(e) => toggleDelete(e, row)}
                >
                  <DeleteIcon />
                </IconButton>
              {/* </PermissionGuard> */}
            </Box>
          ),
        },
      ]}
      currentPage={currentPage}
      pageSize={pageSize}
      setCurrentPage={setCurrentPage}
      setPageSize={setPageSize}
    />
  );
}

export default TableSubAdmin;
